import { Link } from '@liveauctioneers/hammer-ui-core/link';
import { BodySecondary, H5 } from '@liveauctioneers/hammer-ui-core/text';
import { cn } from '@liveauctioneers/hammer-ui-theme/cn';

import { ShippingMethods } from '@/enums/shippingMethod';
import { useIsMobileLayout, useIsTabletLayout } from '@/hooks';

type Props = {
    primaryText: string | JSX.Element;
    secondaryText: string | JSX.Element;
    shippingMethod?: ShippingMethods;
    trackingLink?: string;
};

export const StatusBadge = ({ primaryText, secondaryText, shippingMethod, trackingLink }: Props) => {
    const isMobile = useIsMobileLayout();
    const isTablet = useIsTabletLayout();

    return (
        <div
            className={cn('flex max-w-full flex-col', {
                'max-w-[700px]': isTablet && !isMobile,
                'max-w-[760px]': !isTablet && !isMobile,
            })}
        >
            <H5 className="flex">{primaryText}</H5>
            <section>
                <BodySecondary color="secondary">{secondaryText}</BodySecondary>
                {shippingMethod === ShippingMethods.LiveShipping && Boolean(trackingLink) && (
                    <Link
                        className="ml-2xs"
                        href={trackingLink}
                        size="sm"
                        target="_blank"
                    >
                        View Tracking History
                    </Link>
                )}
            </section>
        </div>
    );
};
